module.exports = __webpack_public_path__ + "static/media/image34.babd61ea.jpg";